import React, { Component } from "react";
import F from "../../Functions";
import axios from "axios";
import Pagination from "../../components/pagination";
import DataHandler from "../../utils/DataHandler";
import { Row, Col, Card, Icon, Input, Table, Button, message } from "antd";
import ConfirmationModal from "../../components/confirmation-modal";
import { Translate } from "react-translated";
import { debounceQuery } from "../../utils/Constants";

class RSAdmin extends Component {
  state = {
    loading: true,
    users: [],
    page: 1,
    total_pages: 0,
    user: {},
    search: "",
    show_activate_rs_modal: false
  };
  componentDidMount = () => {
    this.loadagency()
  };



  loadagency=()=>{
    this.loadUsers(1);

    // set Review Scheduler List Callback to update
    DataHandler.setReviewSchedulerListCallback(this.loadUsers);
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.location.state !== this.props.location.state) {
      this.loadagency()
    }
  };

  loadUsers = (page) => {
    const filters = [];
    filters.push({ name: "active", op: "==", val: 0 });
    filters.push({ name: "user_type", op: "==", val: "REVIEWSCHEDULER" });
    const searchPurify = F.removeSpecialCharactersFromString(this.state.search);

    if (searchPurify.trim().length > 0) {
      filters.push({
        or: [
          {
            name: "first_name",
            op: "like",
            val: encodeURIComponent("%" + searchPurify + "%")
          },
          {
            name: "last_name",
            op: "like",
            val: encodeURIComponent("%" + searchPurify + "%")
          },
          {
            name: "email",
            op: "like",
            val: encodeURIComponent("%" + searchPurify + "%")
          }
        ]
      });
    }

    const nPage = page === undefined ? 1 : page;

    const api =
      "/api/users?page=" +
      nPage +
      '&q={"filters":' +
      JSON.stringify(filters) +
      "}";
    this.setState({ loading: true });
    axios.get(api).then((res) => {
      this.setState({
        loading: false,
        users: res.data.objects,
        page: res.data.page,
        total_pages: res.data.total_pages
      });
    });
  };

  componentWillUnmount() {
    DataHandler.setReviewSchedulerListCallback(null);
  }

  activateRS = () => {
    // payload
    const data = {
      rs_id: this.state.user.id
    };

    this.setState({
      loading: true
    });

    axios
      .post("/api/activate_rs_user", data)
      .then((res) => {
        this.setState({
          loading: false
        });

        const response = res.data;

        if (response.success) {
          message.success(response.message);

          // handle callback
          const callback = DataHandler.getReviewSchedulerListCallback();
          callback && callback();
        } else {
          message.error(response.message);
        }

        this.props.hideModal();
      })
      .catch((error) => {
        F.log(error);
        this.setState({
          loading: false
        });
      });
  };

  confirmAction = () => {
    this.setState({ show_activate_rs_modal: false }, () => {
      this.activateRS();
    });
  };

  cancelAction = () => {
    this.setState({ show_activate_rs_modal: false });
  };
  searchUser = (event) => {
    this.setState({ search: event.target.value }, () => {
      debounceQuery(this.loadUsers.bind(this, 1));
    });
  };

  refreshInfo = () => {
    this.setState({ search: "" }, () => {
      this.loadUsers(this.state.page);
    });
  };
  render() {
    const { loading, users, page, total_pages, user } = this.state;
    const columns = [
      {
        title: "First Name",
        dataIndex: "first_name",
        key: "first_name"
      },
      {
        title: "Last Name",
        dataIndex: "last_name",
        key: "last_name"
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email"
      },
      // {
      //     title: 'Phone',
      //     dataIndex: 'phone',
      //     key: 'phone'
      // },
      {
        title: "",
        dataIndex: "action",
        key: "action"
      }
    ];

    const data = [];
    for (let i = 0; i < users.length; i++) {
      let user = users[i];

      data.push({
        key: i,
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        phone: user.phone,
        action: (
          <div className="right-align">
            <Button
              onClick={() => {
                this.setState({
                  show_activate_rs_modal: true,
                  user
                });
              }}
            >
              <Icon type="user" /> Activate
            </Button>
          </div>
        )
      });
    }

    return (
      <div>
        <Card
          type="inner"
          title={
            <div style={{ paddingTop: 7 }}>
              <Icon type="team" style={{ marginRight: 10, color: "#1890ff" }} />
              Deactivated Review Scheduler
            </div>
          }
          className="tableCard"
          loading={loading}
          extra={
            <div>
              <Row gutter={16}>
                <Col md={50} span={16}>
                  <Input
                    placeholder="Search User"
                    onChange={(e) => this.searchUser(e)}
                    value={this.state.search}
                    style={{ width: "100%" }}
                    onPressEnter={() => {
                      // const searchPurify = F.removeSpecialCharactersFromString(
                      //   this.state.search
                      // );

                      // if (searchPurify.trim().length > 0) {
                      //   this.loadUsers(1);
                      // }
                      this.loadUsers(1);
                    }}
                  />
                </Col>
                <Col md={50} span={8}>
                  <Button icon="reload" onClick={this.refreshInfo}>
                    {" "}
                    <Translate text={`Refresh`} />
                  </Button>
                </Col>
              </Row>
            </div>
          }
        >
          <Table
            columns={columns}
            dataSource={data}
            bordered={false}
            pagination={false}
            locale={{ emptyText: "No Data To Show" }}
          />
          <Pagination
            current_page={page}
            total_pages={total_pages}
            onClick={(page) => {
              this.loadUsers(page);
            }}
          />
        </Card>

        <ConfirmationModal
          showModal={this.state.show_activate_rs_modal}
          title={`Active "${user.first_name + " " + user.last_name}"`}
          okText="Yes"
          cancelText="No"
          message={
            <span>
              Are you sure you want to activate
              <span style={{ fontWeight: "bold" }}>
                {`"${user.first_name + " " + user.last_name}"`}{" "}
              </span>
              ?
            </span>
          }
          ok={this.confirmAction}
          cancel={this.cancelAction}
        />
      </div>
    );
  }
}

export default RSAdmin;



// WEBPACK FOOTER //
// ./src/scenes/SuperAdmin/rs-admin-deactivate.js